import {
  CapaQuotationDetailedMaterialType,
  CapaQuotationDetailedServiceType,
  CapaQuotationMaterial,
  CapaQuotationRecommendation,
  CapaQuotationServiceType
} from '@generated/graphql';

interface selectOptionsWithDetailedMaterial {
  'detailedServiceType': CapaQuotationDetailedServiceType[];
  'material': CapaQuotationMaterial[];
  'detailedMaterial': Partial<
    Record<CapaQuotationMaterial, CapaQuotationDetailedMaterialType[]>
  >;
}

interface selectOptionsWithoutDetailedMaterial {
  'detailedServiceType': CapaQuotationDetailedServiceType[];
  'material': Partial<
    Record<CapaQuotationDetailedServiceType, CapaQuotationMaterial[]>
  >;
}

export const selectCNCOptions: selectOptionsWithDetailedMaterial = {
  'detailedServiceType': [
    CapaQuotationDetailedServiceType.Milling,
    CapaQuotationDetailedServiceType.Turning,
    CapaQuotationDetailedServiceType.MachiningCenter,
    CapaQuotationDetailedServiceType.Drilling,
    CapaQuotationDetailedServiceType.Recommend
  ],
  'material': [
    CapaQuotationMaterial.Plastic,
    CapaQuotationMaterial.Aluminum,
    CapaQuotationMaterial.StainlessSteel,
    CapaQuotationMaterial.Steel,
    CapaQuotationMaterial.Copper,
    CapaQuotationMaterial.CarbonSteel,
    CapaQuotationMaterial.Bronze,
    CapaQuotationMaterial.Brass,
    CapaQuotationMaterial.SteelAlloy,
    CapaQuotationMaterial.Recommend
  ],
  'detailedMaterial': {
    [CapaQuotationMaterial.Plastic]: [
      CapaQuotationDetailedMaterialType.Abs,
      CapaQuotationDetailedMaterialType.Acryl,
      CapaQuotationDetailedMaterialType.McNylon,
      CapaQuotationDetailedMaterialType.McNylon_66,
      CapaQuotationDetailedMaterialType.Pc,
      CapaQuotationDetailedMaterialType.Pe,
      CapaQuotationDetailedMaterialType.Pp,
      CapaQuotationDetailedMaterialType.AcetalPom,
      CapaQuotationDetailedMaterialType.Peek,
      CapaQuotationDetailedMaterialType.Bakelite,
      CapaQuotationDetailedMaterialType.Teflon,
      CapaQuotationDetailedMaterialType.Etc,
      CapaQuotationDetailedMaterialType.Recommend
    ],
    [CapaQuotationMaterial.Aluminum]: [
      CapaQuotationDetailedMaterialType.Aluminum_2024T3,
      CapaQuotationDetailedMaterialType.Aluminum_6061T6,
      CapaQuotationDetailedMaterialType.Aluminum_6063,
      CapaQuotationDetailedMaterialType.Aluminum_7050,
      CapaQuotationDetailedMaterialType.Aluminum_7075T6,
      CapaQuotationDetailedMaterialType.Aluminum_7075T7351,
      CapaQuotationDetailedMaterialType.AluminumMic_6,
      CapaQuotationDetailedMaterialType.Aluminum_2024T3,
      CapaQuotationDetailedMaterialType.Etc,
      CapaQuotationDetailedMaterialType.Recommend
    ],
    [CapaQuotationMaterial.StainlessSteel]: [
      CapaQuotationDetailedMaterialType.Ss15_5,
      CapaQuotationDetailedMaterialType.Ss17_4,
      CapaQuotationDetailedMaterialType.Ss18_8,
      CapaQuotationDetailedMaterialType.Ss303,
      CapaQuotationDetailedMaterialType.Ss304,
      CapaQuotationDetailedMaterialType.Ss316Ss316L,
      CapaQuotationDetailedMaterialType.Ss416,
      CapaQuotationDetailedMaterialType.Ss420,
      CapaQuotationDetailedMaterialType.Etc,
      CapaQuotationDetailedMaterialType.Recommend
    ],
    [CapaQuotationMaterial.Steel]: [
      CapaQuotationDetailedMaterialType.Ss235Ss330,
      CapaQuotationDetailedMaterialType.Ss275Ss400,
      CapaQuotationDetailedMaterialType.Ss315Ss490,
      CapaQuotationDetailedMaterialType.Ss410Ss540,
      CapaQuotationDetailedMaterialType.Ss450Ss590,
      CapaQuotationDetailedMaterialType.Ss550,
      CapaQuotationDetailedMaterialType.Etc,
      CapaQuotationDetailedMaterialType.Recommend
    ],
    [CapaQuotationMaterial.Copper]: [
      CapaQuotationDetailedMaterialType.Copper_101,
      CapaQuotationDetailedMaterialType.Copper_260Brass,
      CapaQuotationDetailedMaterialType.CopperC110,
      CapaQuotationDetailedMaterialType.CopperC360Brass,
      CapaQuotationDetailedMaterialType.CopperC932Bronze,
      CapaQuotationDetailedMaterialType.Etc,
      CapaQuotationDetailedMaterialType.Recommend
    ],
    [CapaQuotationMaterial.CarbonSteel]: [
      CapaQuotationDetailedMaterialType.S10CSm10C,
      CapaQuotationDetailedMaterialType.S15CSm15C,
      CapaQuotationDetailedMaterialType.S20CSm20C,
      CapaQuotationDetailedMaterialType.S25CSm25C,
      CapaQuotationDetailedMaterialType.S30CSm30C,
      CapaQuotationDetailedMaterialType.S35CSm35C,
      CapaQuotationDetailedMaterialType.S40CSm40C,
      CapaQuotationDetailedMaterialType.S45CSm45C,
      CapaQuotationDetailedMaterialType.S50CSm50C,
      CapaQuotationDetailedMaterialType.S55CSm55C,
      CapaQuotationDetailedMaterialType.Etc,
      CapaQuotationDetailedMaterialType.Recommend
    ],
    [CapaQuotationMaterial.Brass]: [
      CapaQuotationDetailedMaterialType.GeneralBrass,
      CapaQuotationDetailedMaterialType.Etc,
      CapaQuotationDetailedMaterialType.Recommend
    ],
    [CapaQuotationMaterial.Bronze]: [
      CapaQuotationDetailedMaterialType.GeneralBronze,
      CapaQuotationDetailedMaterialType.Etc,
      CapaQuotationDetailedMaterialType.Recommend
    ],
    [CapaQuotationMaterial.SteelAlloy]: [
      CapaQuotationDetailedMaterialType.Scm_415,
      CapaQuotationDetailedMaterialType.Scm_420,
      CapaQuotationDetailedMaterialType.Scm_440,
      CapaQuotationDetailedMaterialType.Etc,
      CapaQuotationDetailedMaterialType.Recommend
    ],
    [CapaQuotationMaterial.Recommend]: []
  }
};

export const selectMoldingOptions: selectOptionsWithDetailedMaterial = {
  'detailedServiceType': [
    CapaQuotationDetailedServiceType.InjectionMolding,
    CapaQuotationDetailedServiceType.DoubleShotInjectionMolding,
    CapaQuotationDetailedServiceType.BlowInjectionMolding,
    CapaQuotationDetailedServiceType.InsertInjectionMolding,
    CapaQuotationDetailedServiceType.Recommend
  ],
  'material': [
    CapaQuotationMaterial.Plastic,
    CapaQuotationMaterial.MetalInj,
    CapaQuotationMaterial.Recommend
  ],
  'detailedMaterial': {
    [CapaQuotationMaterial.Plastic]: [
      CapaQuotationDetailedMaterialType.Abs,
      CapaQuotationDetailedMaterialType.Asa,
      CapaQuotationDetailedMaterialType.Hdpe,
      CapaQuotationDetailedMaterialType.Ldpe,
      CapaQuotationDetailedMaterialType.NylonPa,
      CapaQuotationDetailedMaterialType.Pbt,
      CapaQuotationDetailedMaterialType.Pc,
      CapaQuotationDetailedMaterialType.Pct,
      CapaQuotationDetailedMaterialType.Pe,
      CapaQuotationDetailedMaterialType.Peek,
      CapaQuotationDetailedMaterialType.Pei,
      CapaQuotationDetailedMaterialType.Pet,
      CapaQuotationDetailedMaterialType.Pmma,
      CapaQuotationDetailedMaterialType.AcetalPom,
      CapaQuotationDetailedMaterialType.Pp,
      CapaQuotationDetailedMaterialType.Ps,
      CapaQuotationDetailedMaterialType.Pvc,
      CapaQuotationDetailedMaterialType.Tpe,
      CapaQuotationDetailedMaterialType.Tpu,
      CapaQuotationDetailedMaterialType.Recommend
    ],
    [CapaQuotationMaterial.MetalInj]: [
      CapaQuotationDetailedMaterialType.AluminumAlloy,
      CapaQuotationDetailedMaterialType.ZincAlloy,
      CapaQuotationDetailedMaterialType.MagnesiumAlloy,
      CapaQuotationDetailedMaterialType.Ldpe,
      CapaQuotationDetailedMaterialType.Recommend
    ],
    [CapaQuotationMaterial.Recommend]: []
  }
};

export const selectPrintingOptions: selectOptionsWithoutDetailedMaterial = {
  'detailedServiceType': [
    CapaQuotationDetailedServiceType.Sla,
    CapaQuotationDetailedServiceType.Fdm,
    CapaQuotationDetailedServiceType.Polyjet,
    CapaQuotationDetailedServiceType.Mjf,
    CapaQuotationDetailedServiceType.Sls,
    CapaQuotationDetailedServiceType.SlmDmls,
    CapaQuotationDetailedServiceType.Recommend
  ],
  'material': {
    [CapaQuotationDetailedServiceType.Sla]: [
      CapaQuotationMaterial.ResinWhite,
      CapaQuotationMaterial.ResinTransparent,
      CapaQuotationMaterial.ResinTranslucent,
      CapaQuotationMaterial.Recommend
    ],
    [CapaQuotationDetailedServiceType.Fdm]: [
      CapaQuotationMaterial.Pla,
      CapaQuotationMaterial.AbsIndustrial,
      CapaQuotationMaterial.ResinTranslucent,
      CapaQuotationMaterial.Recommend
    ],
    [CapaQuotationDetailedServiceType.Polyjet]: [
      CapaQuotationMaterial.Vero,
      CapaQuotationMaterial.RubberLike,
      CapaQuotationMaterial.Recommend
    ],
    [CapaQuotationDetailedServiceType.Mjf]: [
      CapaQuotationMaterial.Pa12,
      CapaQuotationMaterial.Recommend
    ],
    [CapaQuotationDetailedServiceType.Sls]: [
      CapaQuotationMaterial.Pa12,
      CapaQuotationMaterial.Recommend
    ],
    [CapaQuotationDetailedServiceType.SlmDmls]: [
      CapaQuotationMaterial.Aluminum,
      CapaQuotationMaterial.StainlessSteel,
      CapaQuotationMaterial.Recommend
    ],
    [CapaQuotationDetailedServiceType.Recommend]: []
  }
};

export const selectCastingOptions: selectOptionsWithoutDetailedMaterial = {
  'detailedServiceType': [
    CapaQuotationDetailedServiceType.SandCasting,
    CapaQuotationDetailedServiceType.ShellCasting,
    CapaQuotationDetailedServiceType.InvestmentCasting,
    CapaQuotationDetailedServiceType.DieCasting,
    CapaQuotationDetailedServiceType.CentrifugalCasting
  ],
  'material': {
    [CapaQuotationDetailedServiceType.SandCasting]: [
      CapaQuotationMaterial.Iron,
      CapaQuotationMaterial.Steel,
      CapaQuotationMaterial.AluminumAlloy,
      CapaQuotationMaterial.ZincAlloy,
      CapaQuotationMaterial.MagnesiumAlloy,
      CapaQuotationMaterial.CopperAlloy,
      CapaQuotationMaterial.Etc,
      CapaQuotationMaterial.Recommend
    ],
    [CapaQuotationDetailedServiceType.ShellCasting]: [
      CapaQuotationMaterial.Iron,
      CapaQuotationMaterial.Steel,
      CapaQuotationMaterial.AluminumAlloy,
      CapaQuotationMaterial.ZincAlloy,
      CapaQuotationMaterial.MagnesiumAlloy,
      CapaQuotationMaterial.CopperAlloy,
      CapaQuotationMaterial.Etc,
      CapaQuotationMaterial.Recommend
    ],
    [CapaQuotationDetailedServiceType.InvestmentCasting]: [
      CapaQuotationMaterial.Iron,
      CapaQuotationMaterial.Steel,
      CapaQuotationMaterial.AluminumAlloy,
      CapaQuotationMaterial.ZincAlloy,
      CapaQuotationMaterial.MagnesiumAlloy,
      CapaQuotationMaterial.CopperAlloy,
      CapaQuotationMaterial.Etc,
      CapaQuotationMaterial.Recommend
    ],
    [CapaQuotationDetailedServiceType.DieCasting]: [
      CapaQuotationMaterial.Iron,
      CapaQuotationMaterial.Steel,
      CapaQuotationMaterial.AluminumAlloy,
      CapaQuotationMaterial.ZincAlloy,
      CapaQuotationMaterial.MagnesiumAlloy,
      CapaQuotationMaterial.CopperAlloy,
      CapaQuotationMaterial.Etc,
      CapaQuotationMaterial.Recommend
    ],
    [CapaQuotationDetailedServiceType.CentrifugalCasting]: [
      CapaQuotationMaterial.Iron,
      CapaQuotationMaterial.Steel,
      CapaQuotationMaterial.AluminumAlloy,
      CapaQuotationMaterial.ZincAlloy,
      CapaQuotationMaterial.MagnesiumAlloy,
      CapaQuotationMaterial.CopperAlloy,
      CapaQuotationMaterial.Etc,
      CapaQuotationMaterial.Recommend
    ]
  }
};

export const selectSheetMetalOptions: selectOptionsWithoutDetailedMaterial = {
  'detailedServiceType': [
    CapaQuotationDetailedServiceType.Press,
    CapaQuotationDetailedServiceType.LaserCutting,
    CapaQuotationDetailedServiceType.WaterjetCutting,
    CapaQuotationDetailedServiceType.Recommend
  ],
  'material': {
    [CapaQuotationDetailedServiceType.Press]: [
      CapaQuotationMaterial.Aluminum,
      CapaQuotationMaterial.StainlessSteel,
      CapaQuotationMaterial.CarbonSteel,
      CapaQuotationMaterial.GalvanizedSteel,
      CapaQuotationMaterial.Copper,
      CapaQuotationMaterial.Recommend,
      CapaQuotationMaterial.Etc
    ],
    [CapaQuotationDetailedServiceType.LaserCutting]: [
      CapaQuotationMaterial.Aluminum,
      CapaQuotationMaterial.StainlessSteel,
      CapaQuotationMaterial.CarbonSteel,
      CapaQuotationMaterial.GalvanizedSteel,
      CapaQuotationMaterial.Copper,
      CapaQuotationMaterial.Recommend,
      CapaQuotationMaterial.Etc
    ],
    [CapaQuotationDetailedServiceType.WaterjetCutting]: [
      CapaQuotationMaterial.Aluminum,
      CapaQuotationMaterial.StainlessSteel,
      CapaQuotationMaterial.CarbonSteel,
      CapaQuotationMaterial.GalvanizedSteel,
      CapaQuotationMaterial.Copper,
      CapaQuotationMaterial.Recommend,
      CapaQuotationMaterial.Etc
    ],
    [CapaQuotationDetailedServiceType.Recommend]: []
  }
};

export const recommendationOptions: (
  serviceType: CapaQuotationServiceType
) => CapaQuotationRecommendation[] = (serviceType) => {
  switch (serviceType) {
    case CapaQuotationServiceType.Cnc:
      return [
        CapaQuotationRecommendation.Strength,
        CapaQuotationRecommendation.ThermalStrain,
        CapaQuotationRecommendation.CorrosionResistant,
        CapaQuotationRecommendation.Light,
        CapaQuotationRecommendation.DecideAfterConsulting,
        CapaQuotationRecommendation.Etc
      ];
    case CapaQuotationServiceType.Printing:
      return [
        CapaQuotationRecommendation.Strength,
        CapaQuotationRecommendation.ThermalStrain,
        CapaQuotationRecommendation.Allowance,
        CapaQuotationRecommendation.Flexibility,
        CapaQuotationRecommendation.DecideAfterConsulting,
        CapaQuotationRecommendation.Etc
      ];
    case CapaQuotationServiceType.Casting:
      return [
        CapaQuotationRecommendation.Strength,
        CapaQuotationRecommendation.ThermalStrain,
        CapaQuotationRecommendation.CorrosionResistant,
        CapaQuotationRecommendation.Light,
        CapaQuotationRecommendation.DecideAfterConsulting,
        CapaQuotationRecommendation.Etc
      ];
    case CapaQuotationServiceType.Inj:
      return [
        CapaQuotationRecommendation.ShockResistance,
        CapaQuotationRecommendation.Elasticity,
        CapaQuotationRecommendation.Allowance,
        CapaQuotationRecommendation.ThermalStrain,
        CapaQuotationRecommendation.DecideAfterConsulting,
        CapaQuotationRecommendation.Etc
      ];
    case CapaQuotationServiceType.SheetMetal:
      return [
        CapaQuotationRecommendation.Strength,
        CapaQuotationRecommendation.ThermalStrain,
        CapaQuotationRecommendation.CorrosionResistant,
        CapaQuotationRecommendation.Light,
        CapaQuotationRecommendation.SurfaceQuality,
        CapaQuotationRecommendation.DecideAfterConsulting,
        CapaQuotationRecommendation.Etc
      ];
    default:
      return [];
  }
};
